<!-- Modo Simples: dropdown direto -->
<ng-container *ngIf="modo === 'simples'">
  <p-dropdown
    [options]="dropdownOptions"
    [(ngModel)]="selectedValue"
    optionLabel="label"
    optionValue="value"
    [placeholder]="placeholder"
    (onChange)="onPeriodoSelect($event)"
    [styleClass]="styleClass">
  </p-dropdown>
</ng-container>

<!-- Modo Avancado: button + dialog -->
<ng-container *ngIf="modo === 'avancado'">
  <button pButton type="button"
          [class]="'p-button-outlined ' + styleClass"
          (click)="openFilter()">
    {{ textoExibicao || textoPadrao || texts.pre_definido }}
    <i class="pi pi-chevron-down ml-2"></i>
  </button>

  <p-dialog [(visible)]="showFilterDialog"
            [showHeader]="false" [closable]="false" [draggable]="false"
            [modal]="true" styleClass="dialog-wave-redesign"
            [style]="{ width: '560px' }"
            [contentStyle]="{ 'max-height': '80vh', 'overflow': 'visible' }">

    <div class="dialog-wave-header dialog-wave-header--info">
      <div class="dialog-wave-header-content">
        <div class="dialog-wave-icon-container">
          <i class="pi pi-clock" aria-hidden="true"></i>
        </div>
        <div class="dialog-wave-header-text">
          <h2>{{ texts.tipo_de_filtro }}</h2>
          <p>{{ texts.subtitulo_filtro }}</p>
        </div>
      </div>
      <button class="dialog-wave-close-btn" (click)="showFilterDialog = false; dialogFechado.emit()">
        <i class="pi pi-times"></i>
      </button>
      <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
      <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
      <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
      </svg>
    </div>

    <div class="dialog-wave-body">
    <div class="dialog-content">
      <div class="p-field-radios">
        <p-radioButton name="filterType" value="periods" [label]="texts.periodos" [(ngModel)]="filterType"></p-radioButton>
        <p-radioButton name="filterType" value="monthDay" [label]="texts.pre_definido" [(ngModel)]="filterType"
                       (onClick)="onMonthDayChange()"></p-radioButton>
      </div>

      <!-- Pre-definido -->
      <ng-container *ngIf="filterType === 'monthDay'">
        <div class="row">
          <label class="full">{{ texts.selecao }}</label>
          <p-dropdown class="full"
                      [options]="dropdownOptions"
                      optionLabel="label" optionValue="value"
                      [(ngModel)]="selectedValue"
                      appendTo="body"
                      panelStyleClass="dropdown-panel-above-modal"
                      (onChange)="onMonthDayChange()">
          </p-dropdown>
        </div>
        <div class="row two" [hidden]="!showPredefTimePickers">
          <div>
            <label>{{ texts.horario_inicial }}</label>
            <p-calendar [(ngModel)]="predefStartTime" [defaultDate]="predefStartTime" timeOnly="true" hourFormat="24" [showIcon]="true" icon="pi pi-clock" appendTo="body" panelStyleClass="dropdown-panel-above-modal"></p-calendar>
          </div>
          <div>
            <label>{{ texts.horario_final }}</label>
            <p-calendar [(ngModel)]="predefEndTime" [defaultDate]="predefEndTime" timeOnly="true" hourFormat="24" [showIcon]="true" icon="pi pi-clock" appendTo="body" panelStyleClass="dropdown-panel-above-modal"></p-calendar>
          </div>
        </div>
      </ng-container>

      <!-- Periodos: data e hora de cada extremo num unico campo -->
      <ng-container *ngIf="filterType === 'periods'">
        <div class="row two periodos">
          <div class="campo-data-hora">
            <label for="periodoFiltroInicio">{{ texts.data_hora_inicial }} <span class="obrigatorio" aria-hidden="true">*</span></label>
            <p-calendar inputId="periodoFiltroInicio"
                        [(ngModel)]="periodoInicio"
                        [defaultDate]="defaultInicio"
                        dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"
                        [showIcon]="true" [required]="true"
                        [placeholder]="texts.placeholder_data_hora"
                        [ariaLabel]="texts.data_hora_inicial"
                        [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }"
                        [class.ng-invalid]="!periodoInicio" [class.ng-dirty]="!periodoInicio"
                        appendTo="body" panelStyleClass="dropdown-panel-above-modal"></p-calendar>
            <small *ngIf="!periodoInicio" class="p-error">{{ texts.data_hora_obrigatoria }}</small>
          </div>
          <div class="campo-data-hora">
            <label for="periodoFiltroFim">{{ texts.data_hora_final }} <span class="obrigatorio" aria-hidden="true">*</span></label>
            <p-calendar inputId="periodoFiltroFim"
                        [(ngModel)]="periodoFim"
                        [defaultDate]="defaultFim"
                        dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"
                        [showIcon]="true" [required]="true"
                        [placeholder]="texts.placeholder_data_hora"
                        [ariaLabel]="texts.data_hora_final"
                        [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }"
                        [class.ng-invalid]="!periodoFim || periodoFimAntesDoInicio"
                        [class.ng-dirty]="!periodoFim || periodoFimAntesDoInicio"
                        appendTo="body" panelStyleClass="dropdown-panel-above-modal"></p-calendar>
            <small *ngIf="!periodoFim" class="p-error">{{ texts.data_hora_obrigatoria }}</small>
            <small *ngIf="periodoFimAntesDoInicio" class="p-error">{{ texts.erro_fim_antes_inicio }}</small>
          </div>
        </div>
      </ng-container>

      <div class="dialog-footer">
        <button pButton [label]="texts.concluir" class="w-full" [disabled]="!podeConcluir" (click)="applyFilter()"></button>
      </div>
    </div>
    </div>
  </p-dialog>
</ng-container>
